import defaultSupervisorFormValidations from 'common/validations/form/defaultSupervisor';

const validateEditSupervisorForm = (values) => {
  const errors = defaultSupervisorFormValidations(values);

  return errors;
};

export default validateEditSupervisorForm;
